export const mapRequirements = (payload) => {
  const keys = Object.keys(payload);
  
  const requirements = keys.reduce((reqAcc, key) => {
    
    if (key === 'colaboradores') {
      reqAcc[key] = payload[key].map(collaborator => ({ value: collaborator.id, label: collaborator.nome }));
      return reqAcc;
    }

    if (key === 'descontos') {
      reqAcc[key] = payload[key].map(discount => ({
        ...discount,
        value: discount.id,
        label: discount.titulo
      }));
      return reqAcc;
    }

    if (key === 'produtos') {
      reqAcc[key] = payload[key].map(product => ({ value: product.id, label: product.titulo }));
      return reqAcc;
    }

    if (key === 'localidades') {
      reqAcc[key] = payload[key].map(location => ({ value: location.id, label: location.descricao, price: location.valor }));
      return reqAcc;
    }

    if (key === 'servicos') {
      reqAcc[key] = payload[key].map(service => ({ value: service.id, label: service.titulo, price: service.valor }));
      return reqAcc;
    }

    if (key === 'seguros') {
      reqAcc[key] = payload[key].map(insurance => ({ value: insurance.id, label: insurance.titulo }));
      return reqAcc;
    }

    if (key === 'uf') {
      reqAcc[key] = Object.keys(payload[key]).map((uf) => ({ value: uf, label: uf }));
      return reqAcc;
    }

    if (key === 'estado_expedidor') {
      reqAcc[key] = Object.keys(payload[key]).map((uf) => ({ value: uf, label: uf }));
      return reqAcc;
    }

    reqAcc[key] = Object.entries(payload[key]).map(([key,value]) => (
      { value: key, label: value }
    ));

    return reqAcc;
  }, {});

  return requirements;
};
